import styled from 'styled-components';

import Button from 'components/Buttons';

export const Title = styled.div`
  display: flex;
  align-items: center;
`;

export const RemoveButton = styled(Button)`
  height: 100%;
  font-size: 12px;
  margin-left: -10px;
`;
